// import { Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { convertToUserDateFormate } from 'utils/helpers'
// import { useNavigate } from "react-router-dom";

function ListOperations({ fetchOperations, operations, setSelectedRows }) {
  const siteUser = useSelector((store) => store.user)

  // let navigate = useNavigate();
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'Date',
      headerName: 'Date',
      width: 110,
      editable: false,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.Date),
    },
    {
      field: 'KLMT',
      headerName: 'Kilométrage',
      width: 200,
      editable: true,
      valueGetter: (params) => `${params.row.KLMT} Km`,
    },
  ]
  return (
    <div
      style={{
        height: 750,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      {/* <Typography variant='h5' sx={{ fontWeight: 600, padding: '10px' }}>
         Véhicules ({operations.count})
      </Typography> */}

      <DataGrid
        rows={operations.results ? operations.results : []}
        columns={columns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        // disableSelectionOnClick
        checkboxSelection
        disableSelectionOnClick
        // onRowClick={(e) => navigate(`/domicile/vehicule/${e.row.id}`)}

        // onRowClick={(params, event) => {
        //   if (event.target.localName === 'div') {
        //     // window.open(params.row.Lien)
        //     navigate(`/domicile/vehicule/{}`)

        //   }
        // }}
      />
    </div>
  )
}
export default ListOperations
